export const NAME = 'core';
export default NAME;
